<template>
  <div>
    <div style="margin-top: 30px"></div>
    <el-form ref="formData" :model="formData" :rules="rules" label-position="right" label-width="100px">
      <el-row>
        <el-col :span="15">
          <el-form-item label="名称" prop="name">
            <el-input v-model="formData.name" placeholder="example：分化图1" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item label="排序" prop="order">
            <el-input v-model="formData.order" placeholder="example：1 2 3" />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="15">
          <el-form-item label="数据" prop="data">
            <el-input v-model="formData.data" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-button type="primary" @click="handleAdd('formData')">确定上传</el-button>
  </div>
</template>

<script>
import axios from "@/axios";
import router from "@/router";

export default {
  name: "DdImage",
  data() {
    return {
      formData: {},
      rules: {
        name: [{ required: true, message: "名称必填项", trigger: "blur" }],
        order: [{ required: true, message: "排序必填项", trigger: "blur" }],
        data: [{ required: true, message: "数据必填项", trigger: "blur" }],
      },
      btndisable: true,
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
  },
  methods: {
    init() {
      const id = this.$route.query.id;
      if (id) {
        axios.get("/sys/dd_image/get/" + id).then((res) => {
          this.formData = res.data.data;
        });
      } else {
        this.formData = {
          id: "",
          name: "",
          order: "",
          data: "",
        };
      }
    },
    handleAdd(VersionName) {
      this.$refs[VersionName].validate((valid) => {
        if (valid) {
          this.formData.data = this.formData.data.replace(/\s+/g, ' ')
          axios.post("/sys/dd_image/save", this.formData).then((res) => {
            this.$message.success(res.data.msg);
            if (res.data.code == "0000") {
              // 保存成功
              this.formData = {
                id: "",
                name: "",
                order: "",
                data: "",
              };
            }
          });
        }
      });
    },
    changebtndisable(btndisable) {
      this.btndisable = btndisable;
    },
  },
};
</script>

<style scoped>
.el-button {
  width: 150px;
}
.pstyle {
  float: left;
  color: red;
}
</style>
